import apiFactory from '@/overmind/effects/api/apiFactory';
import { MachineClock } from '@/overmind/effects/api/networkServiceApi';

import type { Context } from '../..';
import type { defaultApiConfig } from './index';

export const initializeApis = (
  effects: Context['effects'],
  apiConfig: typeof defaultApiConfig
) => {
  effects.api.assets.initialize(() => apiFactory(apiConfig, 'none'));
  effects.api.networkService.initialize(apiConfig, new MachineClock());
  effects.api.orchestrator.initialize(apiConfig);
  effects.api.identity.initialize(apiConfig);
  effects.api.gridPlannerApi.initialize(apiConfig);
};
